import { mapState } from 'vuex'
import marketRules from '@/components/market/market-rules/market-rules.vue';

export default {
  components: {
    marketRules,
  },
  computed: {
    ...mapState('market', ['market']),
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-rules/sushi-market-rules.js